;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="4035fde8-881e-4bb9-b218-9c81c1507257",e._sentryDebugIdIdentifier="sentry-dbid-4035fde8-881e-4bb9-b218-9c81c1507257")}catch(e){}}();import axios from 'axios';
import { convertToHeaderContent } from './contentConverter.js';
import { serializeBaseUrl, serializeConfigurationOptions } from './queryUtils.js';
import '../_virtual/_sentry-release-injection-file.js';

async function fetchHeaderContent({ environment, domain, locale, showCart = true, showCategories = true, showMultilanguage = true, showSearch = true, searchFlyoutOpen = true, correlationId, 
// eslint-disable-next-line no-console
serverLogFn = console.error, isNextJS = true, highlightPath, axiosInstance = axios, }) {
    const configurationOptions = {
        showCart,
        showCategories,
        showMultilanguage,
        showSearch,
        searchFlyoutOpen,
        highlightPath: highlightPath ?? null,
    };
    const localeOptions = { locale, domain };
    const baseUrl = serializeBaseUrl(environment, localeOptions);
    const serializedOptions = serializeConfigurationOptions(configurationOptions);
    const queryUrl = `${baseUrl}?${serializedOptions}`;
    const callerMaybe = process.env.APPLICATION_NAME;
    try {
        const result = await axiosInstance.get(queryUrl, {
            headers: {
                ...(callerMaybe && {
                    'x-caller': callerMaybe,
                }),
                ...(correlationId && {
                    'x-correlation-id': correlationId,
                }),
            },
        });
        return convertToHeaderContent({
            headerServiceResponse: result.data,
            highlightPath,
            isNextJS,
        });
    }
    catch (error) {
        if (typeof window === 'undefined') {
            serverLogFn(error);
        }
        return { isError: true };
    }
}
function isHeaderServiceError(value) {
    return value?.isError === true;
}
function isHeaderContent(value) {
    return value?.domain !== undefined;
}

export { fetchHeaderContent, isHeaderContent, isHeaderServiceError };
//# sourceMappingURL=headerServiceClient.js.map
